import React from "react";

// Recreation of the "real BROKER, LLC" logo mark
const RealLogo = ({ dark = false, className = "" }) => {
  return (
    <div className={`real-logo ${dark ? "real-logo--dark" : ""} ${className}`}>
      <span className="real-word">real</span>
      <span className="real-sub">Broker, LLC</span>
    </div>
  );
};

export default RealLogo;
